// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__8z84t","rotate":"Loader_rotate__Yyq4-"};